import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Old_Home from './pages/Old_Home';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import DownloadForms from './pages/DownloadForms';
import Feedback from './pages/Feedback';
//import Activity from './pages/Activity';
import AddWorksheet from './pages/AddWorksheet';
import ProtectedRoute from './components/ProtectedRoute'; // Import ProtectedRoute
//import NonLoginHome from './pages/NonLoginHome';
import SchoolFeedback from './pages/SchoolFeedback';
import SchoolDashboard from './pages/SchoolDashboard';
import UserUploadsPage from './pages/UserUploadsPage';
//import AnonymousFeedback from './pages/AnonymousFeedback';
//import DownloadSampleForms from './pages/DownloadSampleForms';
import AddResults from './pages/AddResults';
//import AIWorksheetGenerator from './pages/AIWorksheetGenerator';
//import InteractiveAIWorksheetForm from './pages/InteractiveAIWorksheetForm';
import AIQuestionTest from './pages/AIQuestionTest';
import TestResultsDashboard from './pages/TestResultsDashboard';
import VoicetoText from './pages/VoicetoText';
import Support from './pages/Support';
import UserDownloadPage from './pages/UserDownloadPage';
import RequestWorksheet from './pages/RequestWorksheet';
import Tutorials from './pages/Tutorials';
import ParentPortalDashboard from './pages/ParentPortalDashboard';
//import New_Home from './pages/New_Home';
import Eascode_Agent_Lesson from './pages/Eascode_Agent_Lesson';
//import Eascode_Agent_Subject from './pages/Eascode_Agent_Subject';
import CheckMyAnswer from './pages/CheckMyAnswer';
import PaymentSuccess from './pages/PaymentSuccess';
import CompositionHelp from './pages/CompositionHelp';
import ComprehensionTool  from './pages/ComprehensionTool';
import Eascode_Vision from './pages/Eascode_Vision';
import RewardJourney from './pages/RewardJourney';
import CreatorProfile from './pages/CreatorProfile';
import ChapterChat from './pages/ChapterChat';
import AuthLoading from './pages/AuthLoading';
import EascodeChat from './pages/EascodeChat';
import SubmissionThankYou from './pages/SubmissionThankYou';
import ApprovedUserSubmissions from './pages/Approved_User_Submissions';

import { useEffect } from 'react';
//import { messaging,db,auth } from './firebase'; // make sure this exports initialized messaging
//import { getToken } from 'firebase/messaging';
//import { doc, setDoc } from 'firebase/firestore';
//simport { onAuthStateChanged } from 'firebase/auth';
import ReferFriend from './pages/ReferFriend';
import UserQuizPerformance from './pages/UserQuizPerformance';
import LessonSummaryFromPDF from './pages/LessonSummaryFromPDF';
import Eascode_Agent_Lesson_CBSE_NCERT from './pages/Eascode_Agent_Lesson_CBSE_NCERT';
import SchoolLogin from './pages/SchoolLogin';
import UserPendingDownloadPage from './pages/UserPendingDownloadPage';
import BooksDonation from './pages/BooksDonation';
import BooksRequest from './pages/BooksRequest';
import AIQuestionTest_CBSE_NCERT from './pages/AIQuestionTest_CBSE_NCERT';
//import New_Home from './pages/New_Home';
import Email_Worksheet from './pages/Email_Worksheet';
import Worksheet_Quiz_Shared_With_Me from './pages/Worksheet_Quiz_Shared_With_Me';
import Alert_Summary from './pages/Alert_Summary';
import Recent_Activity from './pages/Recent_Activity';
import SameQuiz from './pages/SameQuiz';
import SimilarQuiz from './pages/SimilarQuiz';
import Email_Quiz from './pages/Email_Quiz';
import PremiumUpgradePage from './pages/PremiumUpgradePage'
import SolveWorksheetOnline from './pages/Solve_Worksheet_Online';
import DragDropPalette from './pages/DragDropPalette';
import EasyUnifiedChat from "./pages/EasyUnifiedChat";

function App() {

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/SchoolDashboard" element={<SchoolDashboard />} />
        <Route path="/Feedback" element={<Feedback/>} />
        <Route path="/Tutorials" element={<Tutorials/>} />
        <Route path="/SchoolLogin" element={<SchoolLogin/>} />
        <Route path="/CreatorProfile/:uid" element={<CreatorProfile />} />
        <Route path="PremiumUpgradePage" element={<PremiumUpgradePage/>} />
        <Route path="/auth-loading" element={<AuthLoading />} />
        <Route path="/EascodeChat" element={<EascodeChat />} />
        <Route path="/DragDropPalette" element={<DragDropPalette />} />


        {/* Protected Routes */}
        <Route
          path="/Old_Home"
          element={
            <ProtectedRoute>
              <Old_Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SubmissionThankYou"
          element={
            <ProtectedRoute>
              <SubmissionThankYou />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Approved_User_Submissions"
          element={
            <ProtectedRoute>
              <ApprovedUserSubmissions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-profile"
          element={
            <ProtectedRoute>
              <EditProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/download-forms"
          element={
            <ProtectedRoute>
              <DownloadForms />
            </ProtectedRoute>
          }
        />
		<Route
          path="/AddWorksheet"
          element={
            <ProtectedRoute>
              <AddWorksheet />
            </ProtectedRoute>
          }
        />
        		<Route
          path="/SchoolFeedback"
          element={
            <ProtectedRoute>
              <SchoolFeedback />
            </ProtectedRoute>
          }
        />
      		<Route
          path="/UserUploadsPage"
          element={
            <ProtectedRoute>
              <UserUploadsPage />
            </ProtectedRoute>
          }
        />
      		<Route
          path="/AddResults"
          element={
            <ProtectedRoute>
              <AddResults />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AIQuestionTest"
          element={
            <ProtectedRoute>
              <AIQuestionTest />
            </ProtectedRoute>
          }
        />
        <Route
          path="/TestResultsDashboard"
          element={
            <ProtectedRoute>
              <TestResultsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/VoicetoText"
          element={
            <ProtectedRoute>
              <VoicetoText />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Support"
          element={
            <ProtectedRoute>
              <Support />
            </ProtectedRoute>
          }
        />
        <Route
          path="/UserDownloadPage"
          element={
            <ProtectedRoute>
              <UserDownloadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/RequestWorksheet"
          element={
            <ProtectedRoute>
              <RequestWorksheet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ParentPortalDashboard"
          element={
            <ProtectedRoute>
              <ParentPortalDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/VoicetoText"
          element={
            <ProtectedRoute>
              <VoicetoText />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Eascode_Agent_Lesson"
          element={
            <ProtectedRoute>
              <Eascode_Agent_Lesson />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Solve_Worksheet_Online"
          element={
            <ProtectedRoute>
              <SolveWorksheetOnline />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CheckMyAnswer"
          element={
            <ProtectedRoute>
              <CheckMyAnswer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PaymentSuccess"
          element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CompositionHelp"
          element={
            <ProtectedRoute>
              <CompositionHelp />
            </ProtectedRoute>
          }
        />
      <Route
          path="/ComprehensionTool"
          element={
            <ProtectedRoute>
              <ComprehensionTool />
            </ProtectedRoute>
          }
        />
      <Route
          path="/Eascode_Vision"
          element={
            <ProtectedRoute>
              <Eascode_Vision />
            </ProtectedRoute>
          }
        />
        <Route
          path="/RewardJourney"
          element={
            <ProtectedRoute>
              <RewardJourney />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ReferFriend"
          element={
            <ProtectedRoute>
              <ReferFriend />
            </ProtectedRoute>
          }
        />
        <Route
          path="/UserQuizPerformance"
          element={
            <ProtectedRoute>
              <UserQuizPerformance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/LessonSummaryFromPDF"
          element={
            <ProtectedRoute>
              <LessonSummaryFromPDF />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Eascode_Agent_Lesson_CBSE_NCERT"
          element={
            <ProtectedRoute>
              <Eascode_Agent_Lesson_CBSE_NCERT />
            </ProtectedRoute>
          }
        />
        <Route
          path="/UserPendingDownloadPage"
          element={
            <ProtectedRoute>
              <UserPendingDownloadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/BooksDonation"
          element={
            <ProtectedRoute>
              <BooksDonation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/BooksRequest"
          element={
            <ProtectedRoute>
              <BooksRequest />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AIQuestionTest_CBSE_NCERT"
          element={
            <ProtectedRoute>
              <AIQuestionTest_CBSE_NCERT />
            </ProtectedRoute>
          }
        />
      {/*}  <Route
          path="/New_Home"
          element={
            <ProtectedRoute>
              <New_Home />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/Email_Worksheet"
          element={
            <ProtectedRoute>
              <Email_Worksheet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Worksheet_Quiz_Shared_With_Me"
          element={
            <ProtectedRoute>
              <Worksheet_Quiz_Shared_With_Me />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Alert_Summary"
          element={
            <ProtectedRoute>
              <Alert_Summary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Recent_Activity"
          element={
            <ProtectedRoute>
              <Recent_Activity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SameQuiz"
          element={
            <ProtectedRoute>
              <SameQuiz />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SimilarQuiz"
          element={
            <ProtectedRoute>
              <SimilarQuiz />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Email_Quiz"
          element={
            <ProtectedRoute>
              <Email_Quiz />
            </ProtectedRoute>
          }
        />

      <Route
        path="/ChapterChat"
        element={
          <ProtectedRoute>
            <ChapterChat />
          </ProtectedRoute>
        }
      />

      <Route
        path="/DragDropPalette"
        element={
          <ProtectedRoute>
            <DragDropPalette />
          </ProtectedRoute>
        }
      />

      <Route
        path="/EasyUnifiedChat"
        element={
          <ProtectedRoute>
            <EasyUnifiedChat />
          </ProtectedRoute>
        }
      />

       </Routes>
    </Router>
  );
}

export default App;

